import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import singleSpaCss from 'single-spa-css';
import Root from './root.component';
import './alli-frontend-notifications.css';
import { add, remove } from './slices/notifications';
import store from './store';

const cssLifecycles = singleSpaCss({
    webpackExtractedCss: true,
    shouldUnmount: false,
});

const reactLifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: Root,
    errorBoundary(err, info, props) {
        // Customize the root error boundary for your microfrontend here.
        return null;
    },
});

export const bootstrap = [cssLifecycles.bootstrap, reactLifecycles.bootstrap];

export const mount = [cssLifecycles.mount, reactLifecycles.mount];

export const unmount = [cssLifecycles.unmount, reactLifecycles.unmount];

/*
 * API
 * ---
 *
 * Everything beyond this point is meant to be consumed by other applications
 * to show notifications.
 */

import { SUCCESS, ERROR, WARNING, INFO } from './components/variants';

export { SUCCESS, ERROR, WARNING, INFO };

/**
 * "low level" api to flash a notification to the user.
 *
 * @param string variant one of the constants exported from variants above
 * @param string title the notification title
 * @param string message the notificaiton message
 * @param object options include an `id` or actions
 */
export function addNotification(variant, title, message, options = {}) {
    store.dispatch(
        add({
            autoDelete: 5000,
            ...options,
            variant,
            title,
            message,
        }),
    );
}

export function addSuccessNotification(title, message, options = {}) {
    addNotification(SUCCESS, title, message, options);
}

export function addErrorNotification(title, message, options = {}) {
    addNotification(ERROR, title, message, options);
}

/**
 * Remove a notification and hide it. This only makes sense to do if a the caller
 * provided a _known_ id as an option to `add*Notification` functions above
 */
export function removeNotification(id) {
    return store.dispatch(remove(id));
}
